import Vue from 'vue'
import { Getter, Action, Mutation } from 'vuex-class'
import { Component, Watch } from 'vue-property-decorator'
import Footer from '@/components/footer/footer'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import Header from '@/components/header/header'
import AsideCart from '@/components/asideCart/asideCart'
import ProductsBtn from '@/components/productsBtn/productsBtn'
import { isAlreadyBought, isAvailableInCommerce } from '@/plugins/products_helper'
import CashbackTooltip from '@/components/cashbackTooltip/cashbackTooltip'
import CommerceProduct from '@/components/commerceProduct/commerceProduct'
import BellNotification from "@/components/bellNotification/bellNotification";

@Component({
  components: {
    Header,
    AsideCart,
    Footer,
    ProductCarousel: () => import('@/components/productCarousel/productCarousel'),
    ButtonNumber: () => import('@/components/buttonNumber/buttonNumber'),
    AddCartButton: () => import('@/components/addCartButtom/addCartButtom'),
    modalCar: () => import('@/components/modalCar/modalCar'),
    SkeletonBanner: () => import('@/components/skeletonBanner/skeletonBanner'),
    ModalAddons: () => import('@/components/modalAddons/modalAddons'),
    SkeletonFluid,
    ProductsBtn,
    CashbackTooltip,
    CommerceProduct,
    BellNotification
  }
  // beforeRouteLeave(to, from, next) {
  //   const w = window as any;
  //   try {
  //     w.Intercom('update', {
  //       hide_default_launcher: false
  //     });
  //   } catch (error) {
  //     // Do Nothing!
  //   }
  //   next();
  // }
})
export default class ProductDetail extends Vue {
  // Actions
  @Action action_getCurrentProduct
  @Action action_registerViewProduct;
  @Action action_addCartProducts;
  @Action action_removeCartProducts;
  @Action action_getProductRecommendations;

  // Getters
  @Getter getCurrentProduct: any
  @Getter getCountry
  @Getter getCity
  @Getter getUser
  @Getter getCart
  @Getter getIsUnderMobile;
  @Getter getProductRecommendations;
  @Getter getIsToken: any;

  // Mutations
  @Mutation IS_SELECT_COUNTRY;
  @Mutation CART;
  @Mutation OPEN_CART;
  @Mutation CURRENT_PRODUCT;

  isShowCar = false
  isOpenAddons = false
  isEditAddons = false
  productQuantity = 1
  isCancelButton = false
  isAlreadyBought = false;
  isAddingProduct = false;

  product

  isBtnLoaded = false
  isProductLoaded = false

  showProductDetails = false;
  showProductIngredients = false;
  showProductServingOptions = false;
  showProductComparison = false;

  get getLeftMargin() {
    if(this.isAlreadyBought) {
      return '0';
    }
    return '30px';
  }

  _verifyActive() {
    if(this.getIsToken) {
      for(let item of this.getUser.notification_available_products) {
        if(item === this.product.id) {
          return true
        }    
      }
    } else {
        return false
    }
  }

  async mounted() {
    this.isProductLoaded = false;
    try {
      const productId = this.$route.params.product_id;
      this.isAlreadyBought = isAlreadyBought(productId);
      await this.action_getCurrentProduct({
        idc : this.getCity.id, 
        idp : productId
      });
      await this.action_getProductRecommendations(productId);
      this.product = this.getCurrentProduct;
      if (Object.keys(this.getUser).length > 0) {
        this.action_registerViewProduct(productId);
      }
      this.setPageTitle();
      // this.hideIntercom();
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! No pudimos cargar tu producto. Por favor, intenta de nuevo." + error
      });
    }
    if(!this.getIsUnderMobile) {
      this.showProductComparison = false;
      this.showProductDetails = false;
      this.showProductIngredients = false;
      this.showProductServingOptions = false;
    }
    
    this.isProductLoaded = true;
    this._verifyActive();
  }

  // hideIntercom() {
  //   try {
  //     (window as any).Intercom('update', {
  //       "hide_default_launcher": true
  //     });
  //   } catch (error) {
  //     // Do Nothing
  //   }
  // }

  setPageTitle() {
    if (
      window &&
      window.document &&
      window.document.title &&
      this.getCurrentProduct &&
      this.getCurrentProduct.name
    ) {
      window.document.title = `${this.getCurrentProduct.name} - TodosComemos`;
    }
  }

  get getQuantity() {
    let response = 0;
    const product: any = this.getCurrentProduct;
    if(product && product.id && this.getCart && this.getCart.cart_products) {
      const cartProducts = this.getCart.cart_products;
      const index = cartProducts.findIndex((item) => item.product_id === (this.product as any).id);
      if(cartProducts[index] && cartProducts[index].quantity_total) {
        response = cartProducts[index].quantity_total;
      }
    }
    return response;
  }

  get getPrice() {
    let response = 0;
    if(this.getCurrentProduct && this.getCurrentProduct.price) {
      response = parseFloat(this.getCurrentProduct.price);
    }
    return this._price(response);
  }

  get getBanners() {
    let banners =
      this.getCurrentProduct &&
      Object.keys(this.getCurrentProduct).length &&
      this.getCurrentProduct.product_banners;
    banners.sort((a, b) => a.ordinal - b.ordinal);
    return banners;
  }

  _toggleCard(edit = false) {
    this.isShowCar = !this.isShowCar
  }

  async _addToCartReturn() {
    this.isAddingProduct = true;
    if(isAvailableInCommerce(this.getCurrentProduct.commerce_id)) {
      const requestObject = {
        products: [
          {
            product_id: this.getCurrentProduct.id,
            qty: 1
          }
        ]
      };
      try {
        await this.action_addCartProducts(requestObject);
        await this.dispatchGetProduct();
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "No se pudo agregar el producto. " + error
        });
      }
    }
    this.isAddingProduct = false;
  }

  async dispatchGetProduct() {
    try {
      if(this.getCurrentProduct && this.getCurrentProduct.id) {
        await this.action_getCurrentProduct({
          idc: this.getCity.id,
          idp: this.getCurrentProduct.id
        });
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo."
      });
    }
  }

  _toggleBtn() {
  }

  _onAddons(edit = false) {
    if (edit) this.isEditAddons = true
    this.isOpenAddons = !this.isOpenAddons
  }

  _onCloseAddons() {
    this.isEditAddons = false
    this.isOpenAddons = false
  }

  onButtonNumberMounted() {
    this.isBtnLoaded = true
  }

  _updateQuantity(val) {
    this.productQuantity = val
    this.isCancelButton = this.productQuantity > 0 ? false : true;
  }

  _price(value) {
    let valueReturn: string = this.$currency.format(value, { code: this.getCountry.currency })
    if (this.getCountry.country_code == 'co') {
      let valueReturnSplit: string[] = valueReturn.split(',')
      return valueReturnSplit[0]
    } else {
      return valueReturn
    }
  }

  _discount() {
    if (
      this.getCurrentProduct &&
      this.getCurrentProduct.current_promo &&
      this.getCurrentProduct.current_promo.promo_amount &&
      this.getCurrentProduct.current_promo.promo_type
    ) {
      const discount = parseFloat(this.getCurrentProduct.current_promo.promo_amount);
      const basePrice = parseFloat(this.getCurrentProduct.price);
      const promoType = this.getCurrentProduct.current_promo.promo_type;
      switch (promoType) {
        case "amount":
          return basePrice - discount;
        case "percentage":
          return basePrice - ((basePrice * discount)/100);
      }
    }
  }

  onBackButtonPress() {
    this.$router.go(-1);
    this.CURRENT_PRODUCT(null);
  }

  @Watch('$route', { deep: true })
  async onRouteChange() {
    this.isProductLoaded = false;
    try {
      if(this.$route.params && this.$route.params.product_id) {
        const productId = this.$route.params.product_id;
        await this.action_getCurrentProduct({
          idc : this.getCity.id,
          idp : productId
        });
        this.product = this.getCurrentProduct;
        if (Object.keys(this.getUser).length > 0) {
          this.action_registerViewProduct(productId);
        }
      }
    } catch(error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! No pudimos cargar tu producto. Por favor, intenta de nuevo."
      })
    }
    this.isProductLoaded = true;
  }

  @Watch('isProductLoaded')
  onProductLoaded() {
    if(this.isProductLoaded) {
      this.$nextTick(() => {
        document.getElementById('main').scrollTo(0, 0);
      });
    }
  }
}
